import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  warningIcon: { marginRight: 4, marginBottom: '10px !important' },
  container: {
    position: 'relative',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    color: '#54565B',
  },
  fade: {
    width: '100%',
    height: theme.spacing(3),
    background: 'linear-gradient(to bottom, transparent, white)',
  },
  buttonContainer: {
    position: ['-webkit-sticky', 'sticky'],
    bottom: theme.spacing(1.5),
  },
  buttonBackground: {
    background: 'white',
  },
  closeBtn: {
    marginLeft: 'auto',
    width: 116,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      width: '100%',
    },
  },
}));
